import React from "react";

import { MainContainer } from "./Main.styles";

interface MainProps {
  children: React.ReactNode;
}

/**
 * Main content area within the page layout.
 * Provides a flex container for the primary content.
 */
const Main: React.FC<MainProps> = ({ children }) => {
  return <MainContainer>{children}</MainContainer>;
};

export default Main;
